export default function Logo({ onDark = false }) {
  return (
    <span className="inline-flex items-center gap-2">
      <svg
        viewBox="0 0 32 32"
        className="h-7 w-7"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M29 3 L3 14.5 L13 18.5 Z" fill="#FF7A1A" />
        <path
          d="M29 3 L13 18.5 L16.5 29 Z"
          fill={onDark ? "#FFFFFF" : "#0B1F3A"}
        />
      </svg>
      <span
        className={`font-display text-xl font-extrabold tracking-tight ${
          onDark ? "text-white" : "text-navy"
        }`}
      >
        Web Pilot
      </span>
    </span>
  );
}
